import { __rest } from '../../_virtual/_tslib.js';
import { jsx } from 'react/jsx-runtime';
import { styled, SvgIcon } from '@mui/material';
import { forwardRef } from 'react';

const SvgWrapper = forwardRef(function SvgWrapper(props, ref) {
    const { shouldScale } = props, rest = __rest(props, ["shouldScale"]);
    return (jsx(StyledSvgIcon, Object.assign({ "$shouldScale": shouldScale, fill: "none", height: "24", viewBox: "0 0 24 24", width: "24" }, rest, { ref: ref, children: props.children })));
});
const StyledSvgIcon = styled(SvgIcon)(({ $shouldScale }) => {
    return {
        width: $shouldScale ? "inherit" : "1em",
        height: $shouldScale ? "inherit" : "1em",
    };
});

export { SvgWrapper };
//# sourceMappingURL=SvgWrapper.js.map
